// extracted by mini-css-extract-plugin
export default {"container":"style_container__A0xCb","homeBtn":"style_homeBtn__p-8lO","line":"style_line__FQ2dr","title":"style_title__V2Gp5"};